import React, { useState } from 'react';
import {
  OrganicBlob,
  OrganicBlob2,
  OrganicBlob3,
  CirclePattern,
} from "../../../shared/decorations/OrganicBlob";
import AuthModal from '../../../shared/auth/AuthModal';
import { useAuth } from '../../../core/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export function HeroSection() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleCTA = () => {
    if (!currentUser || !currentUser.emailVerified) {
      // Show auth modal if not authenticated or verified
      setShowAuthModal(true);
    } else {
      // If authenticated and verified, navigate to the game
      navigate('/game');
    }
  };

  return (
    <>
      <section
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {/* Background organic blobs */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            opacity: 0.1,
            pointerEvents: "none",
          }}
        >
          <OrganicBlob
            style={{
              position: "absolute",
              width: "256px",
              height: "256px",
              top: "-5rem",
              left: "-5rem",
              animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
            }}
          />
          <OrganicBlob2
            style={{
              position: "absolute",
              width: "350px",
              height: "350px",
              top: "25%",
              right: "5rem",
              animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
              animationDelay: "0.5s",
            }}
          />
          <OrganicBlob3
            style={{
              position: "absolute",
              width: "400px",
              height: "400px",
              bottom: "-8rem",
              right: "-8rem",
              animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
              animationDelay: "1s",
            }}
          />
          <OrganicBlob
            style={{
              position: "absolute",
              width: "256px",
              height: "256px",
              bottom: "10rem",
              left: "25%",
              animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
              animationDelay: "1.5s",
            }}
          />
          <CirclePattern
            style={{
              position: "absolute",
              width: "192px",
              height: "192px",
              top: "5rem",
              right: "25%",
              opacity: 0.5,
            }}
          />
          <CirclePattern
            style={{
              position: "absolute",
              width: "192px",
              height: "192px",
              bottom: "5rem",
              left: "33%",
              opacity: 0.5,
            }}
          />
        </div>

        <div
          style={{
            position: "relative",
            zIndex: 10,
            maxWidth: "900px",
            margin: "0 auto",
            padding: "0 1.5rem",
            textAlign: "center",
          }}
        >
          {/* Eyebrow */}
          <p
            style={{
              color: "#8B9D83",
              fontSize: "56px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              marginBottom: "2.5rem",
            }}
          >
            HU GAMES
          </p>

          {/* Brand Name */}
          <h1
            style={{
              fontFamily:
                "'Circular', 'Avenir Next Rounded', -apple-system, sans-serif",
              fontSize: "64px",
              fontWeight: 700,
              color: "#FAFAF8",
              letterSpacing: "-0.02em",
              lineHeight: 1.2,
              marginBottom: "3rem",
              padding: "0 1rem",
            }}
          >
            Where Howard plays daily.
          </h1>

          {/* Sub-headline */}
          <div
            style={{
              color: "#E8DCC4",
              fontSize: "20px",
              lineHeight: 1.8,
              marginBottom: "4rem",
              maxWidth: "700px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <p>
              Experience 5 mins of peace playing daily puzzles
              with your community.
            </p>
          </div>

          {/* CTA Button */}
          <button
            onClick={handleCTA}
            style={{
              padding: "1.25rem 2.5rem",
              fontSize: "16px",
              backgroundColor: "#8B9D83",
              color: "#FAFAF8",
              border: "none",
              borderRadius: "24px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 300ms",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "0 0 20px rgba(139, 157, 131, 0.4)";
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            {currentUser && currentUser.emailVerified
              ? 'Play Now'
              : 'Join with @bison.howard.edu'}
          </button>
        </div>
      </section>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        initialMode="signup"
      />
    </>
  );
}
